import script from "./UserLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserLogin.vue?vue&type=script&setup=true&lang=ts"

import "./UserLogin.vue?vue&type=style&index=0&id=174cbfe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-174cbfe8"]])

export default __exports__